module.exports = __webpack_public_path__ + "static/media/speaker3_mobile.ebaf2c03.png";